export default __webpack_public_path__ + "static/media/img-error404.e26bf401.svg";